import React from "react";
// Material core components
// Material core styles
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import SendIcon from "@material-ui/icons/Send";
// Dependencies
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import connect from "react-redux/es/connect/connect";
import { setChangePassword } from "../../../../redux/actions/authActions";
import { bindActionCreators } from "redux";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import _ from "lodash";
import validate from "validate.js";
import { Typography } from "@material-ui/core";

const styles = theme => ({
  drawerPaper: {
    zIndex: 1190,
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },
    [theme.breakpoints.up("md")]: {
      width: "50%"
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%"
    }
  },
  fieldError: {
    color: "red"
  }
});

const changePasswordForm = {
  oldPassword: {
    presence: { allowEmpty: false, message: "is required" }
  },
  newPassword: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      minimum: 8,
      maximum: 99
    },
    format: {
      //eslint-disable-next-line
      pattern: /^(?=.*\d)(?=.*[\^$*.\[\]\{\}\(\)\?\-"!@#%&\/\,><':;|_~`])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      message: "should contain at least one number, special characters, uppercase letter and lowercase letter"
    }
  },
  newPasswordConfirm: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      minimum: 8,
      maximum: 99
    },
    equality: {
      attribute: "newPassword",
      message: "Password do not match",
      comparator: (v1, v2) => {
        return v1 === v2;
      }
    },
    format: {
      //eslint-disable-next-line
      pattern: /^(?=.*\d)(?=.*[\^$*.\[\]\{\}\(\)\?\-"!@#%&\/\,><':;|_~`])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      message: "should contain at least one number, special characters, uppercase letter and lowercase letter"
    }
  }
};

class ChangePassword extends React.Component {
  state = {
    values: {
      oldPassword: "",
      newPassword: "",
      newPasswordConfirm: ""
    },
    touched: {
      oldPassword: false,
      newPassword: false,
      newPasswordConfirm: false
    },
    errors: {
      oldPassword: null,
      newPassword: null,
      newPasswordConfirm: null
    },
    submitError: null,
    isValid: false
  };

  onSubmitForm = event => {
    this.props.setChangePassword(
      this.state.values.oldPassword,
      this.state.values.newPasswordConfirm,
      this.props.history
    );
    event.preventDefault();
  };

  validateForm = _.debounce(() => {
    const { values } = this.state;

    const newState = { ...this.state };
    const errors = validate(values, changePasswordForm);

    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    this.setState(newState);
  }, 300);

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };

    newState.submitError = null;
    newState.touched[field] = true;
    newState.values[field] = value;

    this.setState(newState, this.validateForm);
  };

  render() {
    const { classes, toggleRightSidebar, openDialog } = this.props;
    const { values, errors, touched, isValid } = this.state;

    const showNewPasswordError = touched.newPassword && errors.newPassword;
    const showNewPasswordConfirmError = touched.newPasswordConfirm && errors.newPasswordConfirm;

    return (
      <React.Fragment>
        <Dialog
          open={openDialog}
          onClose={this.props.handleClose}
          aria-labelledby="form-dialog-title"
          disableBackdropClick
        >
          <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
          <DialogContent>
            <DialogContentText>Change your password, enter old and new one in the form below</DialogContentText>
            <form autoComplete="off" onSubmit={this.onSubmitForm}>
              <Grid container>
                <Grid item xs={9}>
                  <TextField
                    required
                    autoFocus
                    id="oldPassword"
                    type="password"
                    label="Current Password:"
                    value={values.oldPassword}
                    onChange={event => this.handleFieldChange("oldPassword", event.target.value)}
                    margin="normal"
                    variant="outlined"
                    style={{ width: "100%" }}
                  />
                  <TextField
                    required
                    id="newPassword"
                    type="password"
                    label="New Password:"
                    value={values.newPassword}
                    onChange={event => this.handleFieldChange("newPassword", event.target.value)}
                    margin="normal"
                    variant="outlined"
                    style={{ width: "100%" }}
                  />
                  {showNewPasswordError && (
                    <Typography className={classes.fieldError} variant="body2">
                      {errors.newPassword[0]}
                    </Typography>
                  )}
                  <TextField
                    required
                    id="newPasswordConfirm"
                    type="password"
                    label="Confirm New Password:"
                    value={values.newPasswordConfirm}
                    onChange={event => this.handleFieldChange("newPasswordConfirm", event.target.value)}
                    margin="normal"
                    variant="outlined"
                    style={{ width: "100%" }}
                  />
                  {showNewPasswordConfirmError && (
                    <Typography className={classes.fieldError} variant="body2">
                      {errors.newPasswordConfirm[0]}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={3}>
                  <div style={{ display: "flex", height: "100%" }}>
                    <Tooltip title="Change Password">
                      <IconButton type="submit" color="secondary" disabled={!isValid} style={{ margin: "auto" }}>
                        <SendIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleRightSidebar} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    cognitoUser: state.auth.cognitoUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        setChangePassword
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ChangePassword));
